export const allCoupons = [
  {
    code: "RK-RESTRA-55",
    title: "Get 55% OFF on your first rk-restra eat order",
    description:
      "Use code RK-RESTRA-55 and get 55% off on your first rk-restra order on Website and Mobile site. Maximum discount: 500",
  },
  {
    code: "RK-RESTRA-70",
    title: "Get 70% OFF on your first rk-restra eat order",
    description:
      "Use code RK-RESTRA-70 and get 70% off on your first rk-restra order on Website and Mobile site. Maximum discount: 550",
  },
  {
    code: "RK-RESTRA-35",
    title: "Get 35% OFF on your first rk-restra eat order",
    description:
      "Use code RK-RESTRA-35 and get 35% off on your first rk-restra order on Website and Mobile site. Order value should be more than 3000 Maximum discount: 200",
  },
  {
    code: "RK-RESTRA-55",
    title: "Get 55% OFF on your first rk-restra eat order",
    description:
      "Use code RK-RESTRA-55 and get 50% off on your first rk-restra order on Website and Mobile site. Maximum discount: 200",
  },
  {
    code: "RK-RESTRA-55",
    title: "Get 55% OFF on your first rk-restra eat order",
    description:
      "Use code RK-RESTRA-15 and get 15% off on your first rk-restra order on Website and Mobile site.",
  },
];

export const bankOfffers = [
  {
    bankImage: "img/bank/induslnd.png",
    title: " Get flat $.30 cashback using Amazon Pay",
    description:
      " Get flat $.30 cashback on orders above $.99 for 10 orders. No code required.",
  },
  {
    bankImage: "img/bank/1.png",
    title: " Get flat $.30 cashback using Amazon Pay",
    description:
      " Get flat $.30 cashback on orders above $.99 for 10 orders. No code required.",
  },
  {
    bankImage: "img/bank/sbi.png",
    title: " Get flat $.30 cashback using Amazon Pay",
    description:
      " Get flat $.30 cashback on orders above $.99 for 10 orders. No code required.",
  },
  {
    bankImage: "img/bank/icici.png",
    title: " Get flat $.30 cashback using Amazon Pay",
    description:
      " Get flat $.30 cashback on orders above $.99 for 10 orders. No code required.",
  },
];
